// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function MultipleSelectEditor(props) {
  var onMultipleChoiceChange = props.onMultipleChoiceChange;
  var multipleSelect = props.multipleSelect;
  var quizMode = props.quizMode;
  var match = React.useState(function (param) {
        return false;
      });
  var setMinErrors = match[1];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setMaxErrors = match$1[1];
  var compareChoices = Belt_List.cmpByLength(MultipleSelect$ReactHooksTemplate.nonEmptyChoices(multipleSelect), MultipleSelect$ReactHooksTemplate.choices(multipleSelect));
  var hasInvalidChoice = compareChoices !== 0;
  var tmp;
  if (MultipleSelect$ReactHooksTemplate.multipleAnswer(multipleSelect) && !quizMode) {
    var x = MultipleSelect$ReactHooksTemplate.maximumSelections(multipleSelect);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: "Minimum Limit",
                          className: "text-darkcharcoal text-sm font-medium mt-2"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("input", {
                                className: "bg-white border border-gray-400 rounded p-2 text-sm mt-2 w-full",
                                max: String(List.length(MultipleSelect$ReactHooksTemplate.choices(multipleSelect))),
                                min: "1",
                                placeholder: "Min",
                                type: "number",
                                value: String(MultipleSelect$ReactHooksTemplate.minimumSelections(multipleSelect)),
                                onChange: (function (e) {
                                    var value = Utils$ReactHooksTemplate.formTargetValue(e);
                                    var choices = List.length(MultipleSelect$ReactHooksTemplate.choices(multipleSelect));
                                    if (value === "") {
                                      Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setMinimumSelections(multipleSelect, value));
                                      return Curry._1(setMinErrors, (function (param) {
                                                    return true;
                                                  }));
                                    } else if (value > choices || value < 1) {
                                      return Curry._1(setMinErrors, (function (param) {
                                                    return true;
                                                  }));
                                    } else {
                                      Curry._1(setMinErrors, (function (param) {
                                              return false;
                                            }));
                                      return Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setMinimumSelections(multipleSelect, value));
                                    }
                                  })
                              })
                        })
                  ]
                }),
            match[0] ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("p", {
                          children: "minimum should be between one and choices count",
                          className: "text-red-500 text-xs float-right pb-2"
                        }),
                    className: "my-3"
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: "Maximum Limit",
                          className: "text-darkcharcoal text-sm font-medium mt-2"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("input", {
                                className: "bg-white border border-gray-400 rounded p-2 text-sm mt-2 w-full",
                                max: String(List.length(MultipleSelect$ReactHooksTemplate.choices(multipleSelect))),
                                placeholder: "Max",
                                type: "number",
                                value: x !== undefined ? String(x) : "",
                                onChange: (function ($$event) {
                                    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                    var minimum = MultipleSelect$ReactHooksTemplate.minimumSelections(multipleSelect);
                                    var choices = List.length(MultipleSelect$ReactHooksTemplate.choices(multipleSelect));
                                    if (value === "") {
                                      return Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setMaximumSelections(multipleSelect, undefined));
                                    } else if (minimum <= value && value <= choices) {
                                      Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setMaximumSelections(multipleSelect, value));
                                      return Curry._1(setMaxErrors, (function (param) {
                                                    return false;
                                                  }));
                                    } else {
                                      return Curry._1(setMaxErrors, (function (param) {
                                                    return true;
                                                  }));
                                    }
                                  })
                              })
                        }),
                    match$1[0] ? JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("p", {
                                  children: "maximum should be between minimum and the choices count",
                                  className: "text-red-500 text-xs float-right pb-2"
                                }),
                            className: "my-3"
                          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                  ]
                })
          ],
          className: "mb-4 pb-4 border-b border-gray-300"
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Multiple Select",
                                    className: "text-darkcharcoal text-sm font-medium"
                                  }),
                              JsxRuntime.jsxs("label", {
                                    children: [
                                      JsxRuntime.jsx("input", {
                                            checked: MultipleSelect$ReactHooksTemplate.multipleAnswer(multipleSelect),
                                            type: "checkbox",
                                            onChange: (function (param) {
                                                var choices = MultipleSelect$ReactHooksTemplate.choices(multipleSelect);
                                                var newChoices = List.map((function (choice) {
                                                        return MultipleSelect$ReactHooksTemplate.setChoiceScore(undefined, choice);
                                                      }), choices);
                                                var updatedMultipleSelect$p = MultipleSelect$ReactHooksTemplate.toggleMultipleAnswer(MultipleSelect$ReactHooksTemplate.setChoices(newChoices, multipleSelect));
                                                Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setMinimumSelections(MultipleSelect$ReactHooksTemplate.setMaximumSelections(updatedMultipleSelect$p, 1), 1));
                                              })
                                          }),
                                      JsxRuntime.jsx("span", {
                                            className: "slider round"
                                          })
                                    ],
                                    className: "switch"
                                  })
                            ],
                            className: "flex justify-between"
                          }),
                      className: "mb-4 pb-4 border-b border-gray-300"
                    }),
                tmp,
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    src: Image$ReactHooksTemplate.plusCircle
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Add option"
                                  })
                            ],
                            className: "flex items-center justify-between gap-1 text-darkcharcoal"
                          }),
                      className: "bg-ghostwhite border border-gray-400\n          flex rounded p-2 text-sm mt-2" + (
                        hasInvalidChoice ? " disabled-input" : " "
                      ),
                      disabled: hasInvalidChoice,
                      onClick: (function (param) {
                          Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setChoice(MultipleSelect$ReactHooksTemplate.makeChoice("", undefined, false, undefined), multipleSelect));
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(List.mapi((function (i, choice) {
                                  var tmp;
                                  if (quizMode) {
                                    var x = MultipleSelect$ReactHooksTemplate.getChoiceScore(choice);
                                    tmp = JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: "Score",
                                                  className: "flex text-darkcharcoal text-sm font-medium w-1/2"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("input", {
                                                        className: "bg-white border border-gray-400 rounded p-2 text-sm mt-2 w-full",
                                                        placeholder: "Score",
                                                        type: "number",
                                                        value: x !== undefined ? String(x) : "",
                                                        onChange: (function (e) {
                                                            var value = Utils$ReactHooksTemplate.formTargetValue(e);
                                                            var isMultipleAnswer = MultipleSelect$ReactHooksTemplate.multipleAnswer(multipleSelect);
                                                            var tmp;
                                                            if (value !== undefined) {
                                                              var scoreStr = Caml_option.valFromOption(value);
                                                              if (scoreStr === "") {
                                                                tmp = MultipleSelect$ReactHooksTemplate.setChoice(MultipleSelect$ReactHooksTemplate.setChoiceScore(undefined, choice), multipleSelect);
                                                              } else if (isMultipleAnswer) {
                                                                tmp = MultipleSelect$ReactHooksTemplate.setChoice(MultipleSelect$ReactHooksTemplate.setChoiceScore(Caml_format.int_of_string(scoreStr), choice), multipleSelect);
                                                              } else {
                                                                var choices = MultipleSelect$ReactHooksTemplate.choices(multipleSelect);
                                                                var newChoices = List.map((function (choice$1) {
                                                                        if (Caml_obj.equal(MultipleSelect$ReactHooksTemplate.choiceId(choice$1), MultipleSelect$ReactHooksTemplate.choiceId(choice))) {
                                                                          return MultipleSelect$ReactHooksTemplate.setChoiceScore(Caml_format.int_of_string(scoreStr), choice$1);
                                                                        } else {
                                                                          return MultipleSelect$ReactHooksTemplate.setChoiceScore(undefined, choice$1);
                                                                        }
                                                                      }), choices);
                                                                tmp = MultipleSelect$ReactHooksTemplate.setChoices(newChoices, multipleSelect);
                                                              }
                                                            } else {
                                                              tmp = MultipleSelect$ReactHooksTemplate.setChoice(MultipleSelect$ReactHooksTemplate.setChoiceScore(undefined, choice), multipleSelect);
                                                            }
                                                            Curry._1(onMultipleChoiceChange, tmp);
                                                          })
                                                      }),
                                                  className: "flex w-1/2"
                                                })
                                          ],
                                          className: "flex items-center border-b border-gray-400 mt-3 pb-3"
                                        });
                                  } else {
                                    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                  }
                                  return JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: "Choice " + String(i + 1 | 0),
                                                      className: "sb-choice-label text-darkcharcoal text-sm font-medium"
                                                    }),
                                                JsxRuntime.jsx("input", {
                                                      className: (
                                                        MultipleSelect$ReactHooksTemplate.getChoiceText(choice) === "" ? "h-40-px py-2 px-4 rounded bg-white border border-red-500 focus:border-red-500 text-xs w-full" : "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full"
                                                      ) + " sb-choice-input",
                                                      placeholder: "Enter Choice " + String(i + 1 | 0),
                                                      type: "text",
                                                      value: MultipleSelect$ReactHooksTemplate.getChoiceText(choice),
                                                      onChange: (function ($$event) {
                                                          var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                          Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setChoice(MultipleSelect$ReactHooksTemplate.setChoiceText(value, choice), multipleSelect));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "sb-choice-delete h-12-px cursor-pointer",
                                                      src: Image$ReactHooksTemplate.trash,
                                                      onClick: (function (param) {
                                                          Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.removeChoice(choice, MultipleSelect$ReactHooksTemplate.choices(multipleSelect), multipleSelect));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Label can't be blank",
                                                      className: MultipleSelect$ReactHooksTemplate.getChoiceText(choice) === "" ? "sb-choice-error text-red-500 text-xs" : "hidden"
                                                    }),
                                                quizMode ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                              checked: MultipleSelect$ReactHooksTemplate.getAllowNonSpecifiedText(choice),
                                                              label: "Enable non specified text",
                                                              handleChange: (function (param) {
                                                                  Curry._1(onMultipleChoiceChange, MultipleSelect$ReactHooksTemplate.setChoice(MultipleSelect$ReactHooksTemplate.toggleAllowNonSpecifiedText(choice), multipleSelect));
                                                                }),
                                                              checkboxClassName: "custom_checkbox"
                                                            }),
                                                        className: "sb-choice-extra text-darkcharcoal text-sm font-light"
                                                      }),
                                                tmp
                                              ],
                                              className: "mb-4 sb-choice-row"
                                            }, RandomId$ReactHooksTemplate.toString(MultipleSelect$ReactHooksTemplate.choiceId(choice)));
                                }), MultipleSelect$ReactHooksTemplate.choices(multipleSelect))),
                      className: "mb-7 mt-4"
                    })
              ]
            });
}

var make = MultipleSelectEditor;

exports.make = make;
/* react Not a pure module */
